<swiper-container #swiperRef pager="true" class="slides tertiary-bullets no-bullets" [options]="slideOpts">
  <swiper-slide *ngFor="let card of cards">
    <app-icon-card [isButtonsPrimary]="true" class="product" [card]="card" type="colors"
      [loading]="loading"></app-icon-card>
  </swiper-slide>
</swiper-container>